module.exports = __webpack_public_path__ + "img/Java_Cup.c0f9e920.svg";